module.exports = __webpack_public_path__ + "assets/130d722c6744187ba62ace9ed58d32d2.png";